import React, { useEffect, useState } from "react";
import { adminListCategories, adminDeleteCategory, adminListSubCategories } from "../api/admin";
import CategoryTable from "../components/CategoryTable";
import CategoryForm from "../components/CategoryForm";
import "./CategoriesPage.css";
import { toast } from "react-toastify";

const CategoriesPage = () => {
  const [categories, setCategories] = useState([]);
  const [subcategoryCounts, setSubcategoryCounts] = useState({});
  const [editingCategory, setEditingCategory] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const role = localStorage.getItem("adminRole");
  const permissions = JSON.parse(localStorage.getItem("adminPermissions") || "[]");

  const hasWritePermission = () => {
    if (role === "admin") return true;
    return permissions.includes("Categories:write");
  };

  const clearEdit = () => {
    setEditingCategory(null);
    setShowForm(false);
  };

  const fetchCategories = async () => {
    try {
      const [catRes, subRes] = await Promise.all([
        adminListCategories(),
        adminListSubCategories()
      ]);

      const cats = catRes.data || [];
      const subs = subRes.data || [];

      // Calculate counts
      const counts = {};
      subs.forEach(sub => {
        const pId = sub.parent_category_id || sub.category_id; // Check both potential fields
        if (pId) {
          counts[pId] = (counts[pId] || 0) + 1;
        }
      });

      setCategories(cats);
      setSubcategoryCounts(counts);
    } catch (error) {
      console.error("Error fetching categories or subcategories:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const filteredCategories = (categories || []).filter(c => {
    const term = searchTerm.toLowerCase();
    return (
      (c.category_name || "").toLowerCase().includes(term) ||
      (c._id || c.id || "").toLowerCase().includes(term)
    );
  });

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this category?")) return;
    try {
      await adminDeleteCategory(id);
      toast.success("Category deleted successfully! 🗑️");
      fetchCategories();
    } catch (error) {
      console.error("Error deleting category:", error);
      toast.error(error.response?.data?.message || "Failed to delete category. ❌");
    }
  };

  const handleEdit = (category) => {
    setEditingCategory(category);
    setShowForm(true);
  };

  return (
    <div className="admin-page">
      {!showForm ? (
        <>
          <div className="page-header">
            <h2 className="adminproducts">Categories</h2>
            <div className="header-actions">
              <div className="search-container">
                <span className="search-label">Search:</span>
                <input
                  type="text"
                  className="user-search-input"
                  placeholder="Find by category name, ID..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="header-controls-row">
                <div className="admin-count-badge">
                  Total Categories: {categories.length}
                </div>
                {hasWritePermission() && (
                  <button className="btn-add-product" onClick={() => { setEditingCategory(null); setShowForm(true); }}>
                    + Add Category
                  </button>
                )}
              </div>
            </div>
          </div>

          <CategoryTable 
            categories={filteredCategories} 
            subcategoryCounts={subcategoryCounts}
            onDelete={handleDelete} 
            onEdit={handleEdit} 
            canWrite={hasWritePermission()}
          />
        </>
      ) : (
        <>
          <div className="page-header">
            <div className="header-with-back">
              <button className="back-btn" onClick={clearEdit}>← Back</button>
              <h2 className="adminproducts">
                {editingCategory ? "Update Category" : "Create New Category"}
              </h2>
            </div>
          </div>
          <div className="form-inline-container">
            <CategoryForm
              category={editingCategory}
              onSuccess={() => {
                fetchCategories();
                clearEdit();
              }}
              onCancel={clearEdit}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default CategoriesPage;

